<template>
  <div class="section-liens d-block d-md-flex">
    <EditableArea
      class="row no-gutters h-100 d-block w-100 w-md-50"
      :content="content.sectionLiens"
      :parentTemplateId="metadata['mgnl:template']"
    />
    <div class="row no-gutters h-100 d-block w-100 w-md-50">
      <ListeLiens
        v-for="collection in collectionsAuto"
        :key="collection.name"
        :content="getContentCollection(collection)"
        :isListeAuto="true"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { EditableArea } from '@/vue-editor';
import ListeLiens from '@/components/container/liste/ListeLiens';
import { PageMappingCasino } from '@/helpers/PageMappingHelpers';
import i18n from '@/js/i18n';

export default {
  name: 'SectionLiens',
  components: {
    EditableArea,
    ListeLiens,
  },
  props: {
    metadata: { type: Object },
    content: { type: Object, required: true },
  },
  data() {
    return {
      collections: [],
      collectionsAuto: [
        {
          name: 'machines-a-sous',
          url: `${PageMappingCasino.CASINO_COLLECTION.siteUrl}/${i18n.t(
            `casino.categorie.mas.slug`
          )}`,
        },
        {
          name: 'jeux-de-table',
          url: `${PageMappingCasino.CASINO_COLLECTION.siteUrl}/${i18n.t(
            `casino.categorie.table.slug`
          )}`,
        },
        {
          name: 'keno',
          url: `${PageMappingCasino.CASINO_COLLECTION.siteUrl}/${i18n.t(
            `casino.categorie.keno.slug`
          )}`,
        },
        {
          name: 'instants',
          url: '/instants',
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      getProduitCollectionByName: 'produitCollection/getByName',
    }),
  },
  methods: {
    getContentCollection(collection) {
      return {
        collection: collection.name,
        isReglesDeJeux: this.content.isReglesDeJeux,
        lien: { lienExterne: collection.url },
      };
    },
  },
};
</script>

<style scoped></style>
